(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

if (this.header) {
	observer.observe(this.header);
}
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.style.transform = 'translateY(-100%)';
};

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
	this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
	this.header.style.transform = 'translateY(0)';
};

if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
	this.header.classList.remove('shopify-section-header-sticky');
	this.header.style.transform = 'translateY(0)';
	this.header.style.transition = 'background var(--duration-short)';
};

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		//console.log(this.predictiveSearch.onFocusOut);
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	}
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
}else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
if (this.disclosures) {
	this.disclosures.forEach(disclosure => disclosure.close());
}
}

}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiplanet-guide-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rebuild = () => {
      const countries = [...document.querySelectorAll('[data-cgl-country]')];
      document.querySelectorAll('[data-cgl-nav]').forEach(nav => {
        nav.replaceChildren();
        countries.forEach(country => {
          const link = document.createElement('a');
          link.href = `#${country.id}`;
          link.textContent = country.dataset.cglCountry;
          nav.append(link);
        });
        nav.hidden = countries.length === 0;
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rebuild, { once: true });
    } else {
      rebuild();
    }
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => {
      document.addEventListener(event, () => requestAnimationFrame(rebuild));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiplanet-media-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
if(!root || root.dataset.hmgReady) return;
root.dataset.hmgReady = '1';
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var hero = root.querySelector('.hmg__hero video');
if(hero){ if(reduce){ hero.removeAttribute('autoplay'); hero.pause(); } else { hero.muted = true; var hp = hero.play(); if(hp && hp.catch) hp.catch(function(){}); } }
var grid = root.querySelector('.hmg__grid');
if(!grid) return;
var items = [].slice.call(grid.querySelectorAll('[data-hmg-item]'));
var gap = parseFloat(getComputedStyle(root).getPropertyValue('--hmg-gap')) || 12;
if('ResizeObserver' in window){
grid.classList.add('is-masonry');
var size = function(it){ if(it.hidden) return; var h = it.getBoundingClientRect().height; it.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil(h + gap)); };
var ro = new ResizeObserver(function(es){ es.forEach(function(e){ size(e.target); }); });
items.forEach(function(it){ ro.observe(it); });
window.addEventListener('resize', function(){ gap = parseFloat(getComputedStyle(root).getPropertyValue('--hmg-gap')) || 12; });
}
var chips = [].slice.call(root.querySelectorAll('.hmg__chip'));
chips.forEach(function(ch){
var f = ch.dataset.filter, n = f === 'all' ? items.length : items.filter(function(it){ return it.dataset.cat === f; }).length;
var s = ch.querySelector('.hmg__chip-n'); if(s) s.textContent = n;
if(n === 0 && f !== 'all') ch.hidden = true;
});
var batch = parseInt(root.dataset.batch, 10) || 24;
var limit = batch, current = 'all';
var sentinel = root.querySelector('.hmg__sentinel');
function matching(){ return items.filter(function(it){ return current === 'all' || it.dataset.cat === current; }); }
function apply(){
var m = matching();
items.forEach(function(it){ it.hidden = true; });
m.forEach(function(it, i){
if(i < limit){ it.hidden = false; if(!it.dataset.seen){ it.dataset.seen = '1'; if(i >= batch) it.classList.add('is-in'); } }
});
if(sentinel) sentinel.hidden = m.length <= limit;
setTimeout(check, 350);
}
function check(){
if(!sentinel || sentinel.hidden) return;
if(sentinel.getBoundingClientRect().top < (window.innerHeight || 800) + 700){ limit += batch; apply(); }
}
if(!('IntersectionObserver' in window)) limit = 1e9;
else if(sentinel) new IntersectionObserver(function(es){ if(es[0].isIntersecting) check(); }, { rootMargin: '700px 0px' }).observe(sentinel);
var bar = root.querySelector('.hmg__bar');
chips.forEach(function(ch){
ch.addEventListener('click', function(){
current = ch.dataset.filter;
chips.forEach(function(c){ c.setAttribute('aria-pressed', c === ch ? 'true' : 'false'); });
limit = batch; apply();
if(bar && bar.getBoundingClientRect().top <= 1){ window.scrollTo({ top: grid.getBoundingClientRect().top + window.pageYOffset - bar.offsetHeight - 12, behavior: reduce ? 'auto' : 'smooth' }); }
});
});
apply();
if(root.dataset.autoplay === 'true' && !reduce && 'IntersectionObserver' in window){
var io = new IntersectionObserver(function(es){
es.forEach(function(e){ var v = e.target; if(e.isIntersecting){ v.muted = true; var p = v.play(); if(p && p.catch) p.catch(function(){}); } else { v.pause(); } });
}, { rootMargin: '150px' });
grid.querySelectorAll('video').forEach(function(v){ v.preload = 'metadata'; io.observe(v); });
}
var dlg = root.querySelector('.hmg-lb');
if(!dlg || typeof dlg.showModal !== 'function') return;
var stage = dlg.querySelector('.hmg-lb__media'), capEl = dlg.querySelector('.hmg-lb__caption'), credEl = dlg.querySelector('.hmg-lb__credit'), cnt = dlg.querySelector('.hmg-lb__count');
var prevB = dlg.querySelector('[data-hmg-prev]'), nextB = dlg.querySelector('[data-hmg-next]');
var photoLabel = root.dataset.photoLabel || 'Photo by';
var list = [], idx = 0;
function link(text, href, rel){
if(!href) return document.createTextNode(text);
var a = document.createElement('a'); a.href = href; a.target = '_blank'; a.rel = 'noopener nofollow' + (rel ? ' ' + rel : ''); a.textContent = text; return a;
}
function render(){
var it = list[idx], d = it.dataset, el;
stage.innerHTML = '';
if(d.kind === 'video'){ el = document.createElement('video'); el.src = d.full; el.controls = true; el.autoplay = true; el.muted = true; el.loop = true; el.playsInline = true; }
else { el = document.createElement('img'); el.src = d.full; el.alt = d.caption || ''; }
stage.appendChild(el);
capEl.textContent = d.caption || '';
credEl.innerHTML = '';
if(d.author){
var a = d.author.replace(/^©\s*/, '');
credEl.appendChild(document.createTextNode(d.author.indexOf('©') === 0 ? '© ' : photoLabel + ' '));
credEl.appendChild(link(a, d.source));
if(d.license){ credEl.appendChild(document.createTextNode(', ')); credEl.appendChild(link(d.license, d.licenseUrl, 'license')); }
}
cnt.textContent = list.length > 1 ? (idx + 1) + ' of ' + list.length : '';
prevB.hidden = nextB.hidden = list.length < 2;
}
function openAt(it){ list = matching(); idx = Math.max(0, list.indexOf(it)); render(); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
function step(d){ if(list.length < 2) return; idx = (idx + d + list.length) % list.length; render(); }
items.forEach(function(it){ it.querySelector('.hmg__open').addEventListener('click', function(){ openAt(it); }); });
dlg.addEventListener('close', function(){ stage.innerHTML = ''; document.documentElement.style.overflow = ''; });
dlg.querySelector('[data-hmg-close]').addEventListener('click', function(){ dlg.close(); });
prevB.addEventListener('click', function(){ step(-1); });
nextB.addEventListener('click', function(){ step(1); });
dlg.addEventListener('click', function(e){ if(e.target === dlg || e.target.classList.contains('hmg-lb__stage') || e.target === stage) dlg.close(); });
dlg.addEventListener('keydown', function(e){ if(e.key === 'ArrowLeft') step(-1); if(e.key === 'ArrowRight') step(1); });
var x0 = null;
dlg.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
dlg.addEventListener('touchend', function(e){ if(x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if(Math.abs(dx) > 50) step(dx < 0 ? 1 : -1); x0 = null; });
}
function all(){ document.querySelectorAll('[data-hmg]').forEach(init); }
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-hmg]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiplanet-pinterest-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.hpgReady) return;
    root.dataset.hpgReady = '1';
    var grid = root.querySelector('.hpg__grid');
    if(!grid) return;
    var items = [].slice.call(grid.querySelectorAll('[data-hpg-item]'));
    var gap = parseFloat(getComputedStyle(root).getPropertyValue('--hpg-gap')) || 16;

    if('ResizeObserver' in window){
      grid.classList.add('is-masonry');
      var size = function(it){ var h = it.getBoundingClientRect().height; it.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil(h + gap)); };
      var ro = new ResizeObserver(function(es){ es.forEach(function(e){ size(e.target); }); });
      items.forEach(function(it){ size(it); ro.observe(it); });
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(root.dataset.autoplay === 'true' && !reduce && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if(e.isIntersecting){ v.muted = true; var p = v.play(); if(p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { rootMargin: '150px' });
      grid.querySelectorAll('video').forEach(function(v){ v.preload = 'metadata'; io.observe(v); });
    }

    var dlg = root.querySelector('.hpg-lb');
    if(!dlg || typeof dlg.showModal !== 'function') return;
    var stage = dlg.querySelector('.hpg-lb__media');
    var cap = dlg.querySelector('.hpg-lb__caption');
    var cnt = dlg.querySelector('.hpg-lb__count');
    var list = items.filter(function(it){ return it.querySelector('button.hpg__open'); });
    var idx = 0;
    if(list.length < 2){ dlg.querySelector('[data-hpg-prev]').hidden = true; dlg.querySelector('[data-hpg-next]').hidden = true; }

    function render(){
      var it = list[idx], k = it.dataset.kind, u = it.dataset.full, el;
      stage.innerHTML = '';
      if(k === 'image'){ el = document.createElement('img'); el.src = u; el.alt = it.dataset.caption || ''; }
      else if(k === 'video'){ el = document.createElement('video'); el.src = u; el.controls = true; el.autoplay = true; el.playsInline = true; }
      else { el = document.createElement('iframe'); el.src = u; el.allow = 'autoplay; fullscreen; picture-in-picture'; el.allowFullscreen = true; el.title = it.dataset.caption || 'Video'; }
      stage.appendChild(el);
      cap.textContent = it.dataset.caption || '';
      cnt.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    }
    function openAt(i){ idx = i; render(); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; }
    function shut(){ dlg.close(); }
    function step(d){ idx = (idx + d + list.length) % list.length; render(); }

    list.forEach(function(it, i){ it.querySelector('button.hpg__open').addEventListener('click', function(){ openAt(i); }); });
    dlg.addEventListener('close', function(){ stage.innerHTML = ''; document.documentElement.style.overflow = ''; });
    dlg.querySelector('[data-hpg-close]').addEventListener('click', shut);
    dlg.querySelector('[data-hpg-prev]').addEventListener('click', function(){ step(-1); });
    dlg.querySelector('[data-hpg-next]').addEventListener('click', function(){ step(1); });
    dlg.addEventListener('click', function(e){ if(e.target === dlg || e.target.classList.contains('hpg-lb__stage') || e.target === stage) shut(); });
    dlg.addEventListener('keydown', function(e){ if(e.key === 'ArrowLeft') step(-1); if(e.key === 'ArrowRight') step(1); });
    var x0 = null;
    dlg.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function(e){ if(x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if(Math.abs(dx) > 50 && list.length > 1) step(dx < 0 ? 1 : -1); x0 = null; });
  }
  function all(){ document.querySelectorAll('[data-hpg]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-hpg]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('related-product', RelatedProduct);
  customElements.define('related-slider', RelatedSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector(".media--first");
                    const secondaryImage = wrapper.querySelector(".media--second");
                    const handleProduct = wrapper.dataset.product;
                    
                    if (event.currentTarget.checked && primaryImage) {
                      wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
                        wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                        wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
                      }
                      
                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
                        const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                          
                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              } 
                            }
                            if (flag == false) {
                              primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                              setTimeout(function(){
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                                if (secondaryImage) {
                                  secondaryImage.remove();                                    
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  })
                })
              })
            }

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
